import { render } from "./BaseRadio.vue?vue&type=template&id=1d815892&scoped=true&ts=true"
import script from "./BaseRadio.vue?vue&type=script&lang=ts"
export * from "./BaseRadio.vue?vue&type=script&lang=ts"

import "./BaseRadio.vue?vue&type=style&index=0&id=1d815892&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d815892"]])

export default __exports__